<template>
  <div>
    <!-- コード入力 -->
    <app-code
      ref="input"
      v-model="localCode1"
      class="app-inline"
      :class="codeOptionClass"
      :disabled="computedDisabled"
      :options="codeOptions1"
      @app-event="onAppEventCode1">
    </app-code>
    -
    <app-code
      ref="input2"
      v-model="localCode2"
      class="app-inline"
      :class="codeOptionClass"
      :disabled="computedDisabled"
      :options="codeOptions2"
      @app-event="onAppEventCode2">
    </app-code>
    -
    <app-code
      ref="input3"
      v-model="localCode3"
      class="app-inline"
      :class="codeOptionClass"
      :disabled="computedDisabled"
      :options="codeOptions3"
      @app-event="onAppEventCode3">
    </app-code>
    <!-- /コード入力 -->
  </div>
</template>

<style>
.app-uketsuke_id-short {
  max-width: 76px;
}
.app-uketsuke_id-long {
  max-width: 121px;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Watch } from 'vue-property-decorator';
import AppInputComponent from '../input/AppInputComponent';
import AppCode from './AppCode';

@Component({
  components: { AppCode }
})
export default class AppUketsukeId extends AppInputComponent {
  get codeOptions1 () {
    return {
      'clearable': false,
      'maxLength': 10, // 取引先グループ記号＋ランダム英字で4文字
      'class': 'app-uketsuke_id-short',
      'upperCase': true
    }
  }
  get codeOptions2 () {
    return {
      'clearable': false,
      'maxLength': 10, // 3桁
      'class': 'app-uketsuke_id-short',
      'upperCase': true
    }
  }
  get codeOptions3 () {
    return {
      'clearable': false,
      'maxLength': 10, // 7桁
      'class': 'app-uketsuke_id-long',
      'upperCase': true
    }
  }

  trimCode (src) {
    if (src !== null && src !== undefined) {
      return src.replace(/:-:/g, '').trim();
    } else {
      return '';
    }
  }

  onChangeUketukeId () {
    const value = this.trimCode(this.localCode1) +
    ':-:' + this.trimCode(this.localCode2) +
    ':-:' + this.trimCode(this.localCode3);
    this.$emit('input', value);
  }

  data () {
    return {
      localCode1: null,
      localCode2: null,
      localCode3: null
    }
  }

  @Watch('value', {immediate: true})
  onValueChange (value) {
    this.localCode1 = '';
    this.localCode2 = '';
    this.localCode3 = '';
    try {
      const codes = value.split(':-:');
      this.localCode1 = codes[0];
      this.localCode2 = codes[1];
      this.localCode3 = codes[2];
    } catch (e) {}
  }

  // コード入力クラス
  get codeOptionClass () {
    const options = this.codeOptions;
    let optionClass = (options && 'class' in options) ? options.class : [this.defaultSize];
    if (this.computedReadonly) {
      if (!Array.isArray(optionClass)) {
        optionClass = [optionClass];
      }
      optionClass.push('is-readonly');
    }
    return optionClass;
  }

  /**
   * 初期化
   * NOTE
   * AppPageで定義されたLifeCycleイベントから実行される
   */
  initialize () {
  }

  /**
   * イベントハンドラ
   */
  onAppEventCode1 (...args) {
    if (args[0] === 'enterkey') {
      // 遷移先でのキーUPイベントを無視する為にnextTickでフォーカス移動
      this.$nextTick().then(() => {
        this.$refs.input2.focus();
      });
      return;
    }
    if (args[0] === 'change') {
      this.$nextTick().then(() => {
        this.onChangeUketukeId();
      });
      return;
    }
    this.$emit('app-event', ...args);
  }

  /**
   * イベントハンドラ
   */
  onAppEventCode2 (...args) {
    if (args[0] === 'enterkey') {
      // 遷移先でのキーUPイベントを無視する為にnextTickでフォーカス移動
      this.$nextTick().then(() => {
        this.$refs.input3.focus();
      });
      return;
    }
    if (args[0] === 'change') {
      this.$nextTick().then(() => {
        this.onChangeUketukeId();
      });
      return;
    }
    this.$emit('app-event', ...args);
  }

  /**
   * イベントハンドラ
   */
  onAppEventCode3 (...args) {
    if (args[0] === 'change') {
      this.$nextTick().then(() => {
        this.onChangeUketukeId();
      });
      return;
    }
    this.$emit('app-event', ...args);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/ex/AppUketsukeId.vue